var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 0.75C0.765625 0.75 0 1.54297 0 2.5V13C0 13.9844 0.765625 14.75 1.75 14.75H8.75C9.70703 14.75 10.5 13.9844 10.5 13V5.125H7C6.50781 5.125 6.125 4.74219 6.125 4.25V0.75H1.75ZM7 0.75V4.25H10.5L7 0.75ZM3.0625 7.75H7.4375C7.65625 7.75 7.875 7.96875 7.875 8.1875C7.875 8.43359 7.65625 8.625 7.4375 8.625H3.0625C2.81641 8.625 2.625 8.43359 2.625 8.1875C2.625 7.96875 2.81641 7.75 3.0625 7.75ZM3.0625 9.5H7.4375C7.65625 9.5 7.875 9.71875 7.875 9.9375C7.875 10.1836 7.65625 10.375 7.4375 10.375H3.0625C2.81641 10.375 2.625 10.1836 2.625 9.9375C2.625 9.71875 2.81641 9.5 3.0625 9.5ZM3.0625 11.25H7.4375C7.65625 11.25 7.875 11.4688 7.875 11.6875C7.875 11.9336 7.65625 12.125 7.4375 12.125H3.0625C2.81641 12.125 2.625 11.9336 2.625 11.6875C2.625 11.4688 2.81641 11.25 3.0625 11.25Z",
    fill: "#53A626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.6836H10.5V14.3672H0V13.6836Z",
    fill: "#53A626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqIcon);
export default __webpack_public_path__ + "static/media/faq-icon.cc0b134d900f51aa1f60230f129c5d8e.svg";
export { ForwardRef as ReactComponent };